import MainLogin from './MainLogin';

export default MainLogin;
export { type TMainLoginProps } from './types';
